import React, {memo} from 'react';
import styled from 'styled-components';

import {SvgAsset} from '*.svg';

import {buildIconAttributes} from '../../../libs/shared/ui/src/components/icon/iconHelpers';
import {ChannelExternalTypesEnum} from '../../models/api/channelBehaviorsModel';
import {ChannelTypesEnum} from '../../models/api/channelCommonTypes';

/*
 * Constants.
 */

export enum ChannelIconSizesEnum {
  SMALL = 'small',
  REGULAR = 'regular',
  BIG = 'big',
}

/* eslint global-require: 0 */
/* eslint react/no-danger: 0 */
const importedChannelIcons: Record<
  ChannelTypesEnum | ChannelExternalTypesEnum,
  Record<ChannelIconSizesEnum, SvgAsset>
> = {
  // Generic.
  [ChannelTypesEnum.IMAP]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/email.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/email.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/email.svg'),
  },
  [ChannelTypesEnum.SMTP]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/email.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/email.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/email.svg'),
  },
  [ChannelTypesEnum.CUSTOM]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/custom.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/custom.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/custom.svg'),
  },

  // Custom Integrations.
  [ChannelTypesEnum.FACEBOOK]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/facebook.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/facebook.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/facebook.svg'),
  },
  [ChannelTypesEnum.FORM]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/form.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/form.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/form.svg'),
  },
  [ChannelTypesEnum.FRONT_CHAT]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/frontChat.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/frontChat.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/frontChat.svg'),
  },
  [ChannelTypesEnum.FRONT_MAIL]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/frontMail.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/frontMail.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/frontMail.svg'),
  },
  [ChannelTypesEnum.GMAIL]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/gmail.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/gmail.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/gmail.svg'),
  },
  [ChannelTypesEnum.GOOGLE_PLAY]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/googlePlay.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/googlePlay.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/googlePlay.svg'),
  },
  [ChannelTypesEnum.INTERCOM]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/intercom.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/intercom.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/intercom.svg'),
  },
  // Should not be used anymore but use front chat icon.
  [ChannelTypesEnum.LAYER_ANON]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/frontChat.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/frontChat.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/frontChat.svg'),
  },
  [ChannelTypesEnum.OFFICE365]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/office365.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/office365.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/office365.svg'),
  },
  [ChannelTypesEnum.SMOOCH]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/smooch.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/smooch.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/smooch.svg'),
  },
  [ChannelTypesEnum.TALKDESK]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/talkdesk.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/talkdesk.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/talkdesk.svg'),
  },
  [ChannelTypesEnum.TRULY]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/callLog.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/callLog.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/callLog.svg'),
  },
  [ChannelTypesEnum.TWILIO]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/twilio.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/twilio.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/twilio.svg'),
  },
  [ChannelTypesEnum.TWILIO_WHATSAPP]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/twilio.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/twilio.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/twilio.svg'),
  },
  [ChannelTypesEnum.TWITTER]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/twitter.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/twitter.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/twitter.svg'),
  },
  [ChannelTypesEnum.TWITTER_DM]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/twitter.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/twitter.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/twitter.svg'),
  },
  [ChannelTypesEnum.YALO_WHATSAPP]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/whatsapp.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/whatsapp.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/whatsapp.svg'),
  },
  [ChannelExternalTypesEnum.DRIFT]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/drift.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/drift.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/drift.svg'),
  },
  [ChannelExternalTypesEnum.DIALPAD]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/dialpad.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/dialpad.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/dialpad.svg'),
  },
  [ChannelExternalTypesEnum.JUSTCALL]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/justCall.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/justCall.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/justCall.svg'),
  },
  [ChannelExternalTypesEnum.YALO]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/yalo.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/yalo.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/yalo.svg'),
  },
  [ChannelExternalTypesEnum.LIVEWEB]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/liveweb.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/liveweb.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/liveweb.svg'),
  },
  [ChannelExternalTypesEnum.INSTAGRAM]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/instagram.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/instagram.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/instagram.svg'),
  },
  [ChannelExternalTypesEnum.MEYA]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/meya.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/meya.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/meya.svg'),
  },
  [ChannelExternalTypesEnum.SENDBEE_WHATSAPP]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/sendbee.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/sendbee.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/sendbee.svg'),
  },
  [ChannelExternalTypesEnum.SLACK]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/slack.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/slack.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/slack.svg'),
  },
  [ChannelExternalTypesEnum.TELEGRAM]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/telegram.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/telegram.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/telegram.svg'),
  },
  [ChannelExternalTypesEnum.POSTSCRIPT]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/postscript.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/postscript.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/postscript.svg'),
  },
  [ChannelExternalTypesEnum.POSTSCRIPT]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/postscript.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/postscript.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/postscript.svg'),
  },
  [ChannelExternalTypesEnum.DIALPAD_SMS]: {
    [ChannelIconSizesEnum.REGULAR]: require('../../assets/channel20/dialpad_sms.svg'),
    [ChannelIconSizesEnum.SMALL]: require('../../assets/channel16/dialpad_sms.svg'),
    [ChannelIconSizesEnum.BIG]: require('../../assets/channel40/dialpad_sms.svg'),
  },
};

// All the possible shapes available.
export const channelIcons = importedChannelIcons;

/*
 * Props.
 */

interface ChannelIconProps {
  className?: string;
  size?: ChannelIconSizesEnum;
  type: ChannelTypesEnum | ChannelExternalTypesEnum;
}

/*
 * Style.
 */

const StyledChannelIconSvg = styled.svg`
  display: block;
  flex-shrink: 0;
`;

/*
 * Component.
 */

export const ChannelIcon = memo<ChannelIconProps>((props) => {
  const {size = ChannelIconSizesEnum.REGULAR, type, className} = props;
  const {content, attributes} = channelIcons[type][size];

  const {viewBox, stroke, width, height, fill} = buildIconAttributes(attributes);

  return (
    <StyledChannelIconSvg
      className={className}
      width={width}
      height={height}
      stroke={stroke}
      viewBox={viewBox}
      fill={fill}
      data-testid={`${type}-${size}`}
      dangerouslySetInnerHTML={{__html: content}}
    />
  );
});
